
import React from 'react';
import { Sparkles, Instagram, Video, Facebook, Mail, Package, Lightbulb, Wand2 } from 'lucide-react';



// Landing Page Component
const LandingPage = ({ onStart }) => {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-4xl w-full text-center space-y-8 animate-fade-in">
        {/* Hero Section */}
        <div className="relative">
          <div className="absolute inset-0 blur-3xl bg-gradient-to-r from-purple-600 to-pink-600 opacity-20" />
          <div className="relative">
            <div className="flex justify-center mb-6">
              <div className="relative">
                <Sparkles className="w-24 h-24 text-purple-400" />
                <div className="absolute inset-0 blur-2xl bg-purple-400 opacity-50 animate-pulse" />
              </div>
            </div>
            <h1 className="text-6xl font-bold mb-4 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
              PromptStudio
            </h1>
            <p className="text-2xl text-gray-300 mb-2">
              Générateur de Prompts Marketing Intelligent
            </p>
            <p className="text-lg text-gray-500">
              Créez des prompts professionnels en quelques clics • Optimisé IA • 100% Gratuit
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {[
            { icon: <Instagram className="w-8 h-8" />, title: 'Posts Instagram', desc: 'Légendes engageantes et virales' },
            { icon: <Video className="w-8 h-8" />, title: 'Scripts TikTok', desc: 'Contenus courts et percutants' },
            { icon: <Facebook className="w-8 h-8" />, title: 'Facebook Ads', desc: 'Campagnes publicitaires optimisées' },
            { icon: <Mail className="w-8 h-8" />, title: 'Emails Promo', desc: 'Messages persuasifs et convertissants' },
            { icon: <Package className="w-8 h-8" />, title: 'Fiches Produits', desc: 'Descriptions SEO-friendly' },
            { icon: <Lightbulb className="w-8 h-8" />, title: 'Idées de Contenu', desc: 'Calendriers éditoriaux créatifs' }
          ].map((feature, idx) => (
            <div key={idx} className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10 hover:border-purple-500/30 transition-all hover:scale-105">
              <div className="text-purple-400 mb-3 flex justify-center">{feature.icon}</div>
              <h3 className="text-white font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-400 text-sm">{feature.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={onStart}
          className="group relative px-12 py-6 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl font-bold text-white text-xl shadow-2xl hover:shadow-purple-500/50 transition-all duration-300 hover:scale-105 mt-8"
        >
          <span className="flex items-center space-x-3">
            <Wand2 className="w-6 h-6" />
            <span>Commencer Gratuitement</span>
          </span>
          <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-purple-400 to-pink-400 opacity-0 group-hover:opacity-20 transition-opacity blur-xl" />
        </button>

        {/* Stats */}
        <div className="flex justify-center space-x-12 mt-12 text-center">
          <div>
            <div className="text-3xl font-bold text-purple-400">6+</div>
            <div className="text-gray-500 text-sm">Types de Prompts</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-pink-400">∞</div>
            <div className="text-gray-500 text-sm">Générations</div>
          </div>
          <div>
            <div className="text-3xl font-bold text-purple-400">100%</div>
            <div className="text-gray-500 text-sm">Gratuit</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;